import { VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { Box, IStackProps } from 'native-base';
import React from 'react';

import { SkeletonItemDesktop } from './desktop';
import { SkeletonItemMobile } from './mobile';

interface SkeletonItemProps extends IStackProps {
  itemsCount?: number;
}

export const SkeletonItem: React.FC<SkeletonItemProps> = ({ itemsCount = 1, ...rest }) => {
  const skeleton = useBreakpointValue({
    base: <SkeletonItemMobile />,
    sm: <SkeletonItemDesktop />,
  });

  const data = Array.from({ length: itemsCount }, (_, i) => i);

  return (
    <VStack divider={<Box py={Spacing['inline.quarck']} />} pb={Spacing['inset.nano']} {...rest}>
      {data.map((item) => (
        <Box key={item.toString()}>{skeleton}</Box>
      ))}
    </VStack>
  );
};
